import React from 'react';
import './App.css';

// Component
// import MainPractice from './Components/MainPractice';
import WeatherPage from './Components/WeatherPage';

function App() {
  return (
    <>
      {/* <MainPractice /> */}
      <WeatherPage />
    </>
  );
}

export default App;
